import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core';
import { NotFound } from 'components/NotFound';
import { AclRoutes } from 'routes/AclRoutes';
import { AuthRoutes } from 'routes/AuthRoutes';
import { CustomersRoutes } from 'routes/CustomersRoutes';
import { ProductsRoutes } from 'routes/ProductsRoutes';
import { DatasheetsRoutes } from 'routes/DatasheetsRoutes';
import { SitesRoutes } from 'routes/SitesRoutes';
import { DocumentsRoutes } from 'routes/DocumentsRoutes';
import { UsersRoutes } from 'routes/UsersRoutes';
import { ProfileRoutes } from 'routes/ProfileRoutes';
import { getAuth, isUserAuthenticated } from 'features/Auth/auth';
import { theme } from 'theme/Theme';
import { GlobalStyles } from 'theme/GlobalStyles';
import {
  aclPrefix,
  authPrefix,
  customersPrefix,
  datasheetsPrefix,
  documentsPrefix,
  productsPrefix,
  sitesPrefix,
  usersPrefix,
  profilePrefix,
  qrPrefix
} from 'routes/routes';
import QRPreview from 'features/Preview/QRPreview';

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(isUserAuthenticated);

  useEffect(() => {
    dispatch(getAuth());
  }, [dispatch]);

  if (isAuthenticated === null) {
    return <></>;
  }

  return (
    <MuiThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <Switch>
          <Route exact path="/">
            {isAuthenticated ? <Redirect to={productsPrefix} /> : <Redirect to={authPrefix} />}
          </Route>
          <Route path={authPrefix} component={AuthRoutes} />
          <Route path={productsPrefix} component={ProductsRoutes} />
          <Route path={sitesPrefix} component={SitesRoutes} />
          <Route path={documentsPrefix} component={DocumentsRoutes} />
          {/* <Route path={datasheetsPrefix} component={DatasheetsRoutes} /> */}
          <Route path={usersPrefix} component={UsersRoutes} />
          <Route path={customersPrefix} component={CustomersRoutes} />
          <Route path={aclPrefix} component={AclRoutes} />
          <Route path={profilePrefix} component={ProfileRoutes} />
          <Route path={qrPrefix} component={QRPreview} />
          <Route path="*" component={NotFound} status={404} />
        </Switch>
      </Router>
    </MuiThemeProvider>
  );
};

export { App };
